/** 저작권·이용 안내 (© 2025 김영중) */

export const COPYRIGHT_OWNER = '김영중';
export const COPYRIGHT_YEAR = 2025;
export const COPYRIGHT_CONTACT_EMAIL = 'obnahite@nate.com';
export const SYSTEM_NAME = '노인일자리 참여자 관리 시스템';

export const COPYRIGHT_SHORT_LINE =
  `© ${COPYRIGHT_YEAR} ${COPYRIGHT_OWNER} · ${SYSTEM_NAME} — 무단 사용·배포 금지 · 문의: ${COPYRIGHT_CONTACT_EMAIL}`;

export const COPYRIGHT_SUMMARY = [
  `본 ${SYSTEM_NAME}(이하 "본 시스템")에 포함된 프로그램, 화면, 문서, 데이터 구조 및 관련 자료 일체에 대한 저작권 및 기타 지적재산권은 ${COPYRIGHT_OWNER}에게 있습니다.`,
  '본 시스템의 무단 사용, 복제, 수정, 배포, 재판매, 임대, 2차 저작물 작성 및 이를 목적으로 한 역설계·디컴파일·소스코드 추출 등을 엄격히 금지합니다. 사전 서면 동의 없이는 어떠한 형태로도 이용할 수 없습니다.',
  '본 시스템은 허가된 사용자가 업무 목적으로만 이용해야 합니다.',
  `사용·배포·라이선스·기술 지원 문의: ${COPYRIGHT_CONTACT_EMAIL}`,
];

export const COPYRIGHT_SECTIONS = [
  {
    title: '1. 저작권의 귀속',
    paragraphs: [
      `본 ${SYSTEM_NAME}(이하 "본 시스템") 및 이에 수반되는 소프트웨어, 사용자 인터페이스, 설계·구조, 문서, 로고, 안내 문구 등(이하 "콘텐츠")에 대한 저작권 및 관련 지적재산권은 ${COPYRIGHT_OWNER}(이하 "권리자")에게 귀속됩니다.`,
      `© ${COPYRIGHT_YEAR} ${COPYRIGHT_OWNER}. All rights reserved.`,
    ],
  },
  {
    title: '2. 허용되는 이용',
    paragraphs: [
      '본 시스템은 권리자가 명시적으로 허용한 범위 내에서, 정식으로 부여받은 계정을 통해 업무상 목적으로만 이용할 수 있습니다.',
    ],
  },
  {
    title: '3. 금지 행위',
    paragraphs: [
      '다음 행위는 엄격히 금지됩니다.',
    ],
    list: [
      '권리자의 사전 서면 동의 없는 무단 사용, 복제, 배포, 공개, 전송, 판매, 임대, 양도',
      '본 시스템 또는 그 일부의 수정, 변형, 2차 저작물 작성',
      '역설계, 디컴파일, 디스어셈블 등을 통한 소스코드·구조의 추출',
      '본 시스템을 제3자에게 제공·공유하거나 다른 서비스에 통합·재이용하는 행위',
      '본 안내를 위반한 재배포(영리·비영리 목적 불문)',
    ],
    afterList:
      '위반 시 관련 법령에 따른 민·형사상 책임을 질 수 있습니다.',
  },
  {
    title: '4. 면책',
    paragraphs: [
      '본 시스템은 "있는 그대로" 제공됩니다. 권리자는 법령이 허용하는 범위 내에서 시스템 이용과 관련한 손해에 대한 책임을 제한할 수 있습니다.',
    ],
  },
  {
    title: '5. 문의',
    paragraphs: [
      '본 시스템의 사용, 배포, 라이선스, 기술 지원 등과 관련한 문의는 아래로 연락해 주시기 바랍니다.',
    ],
  },
];
